import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  year: number;
  cars?: number;
  events?: number;
  collections?: number;
  onOpen?: () => void;
};

export const PassportRecapTeaser: React.FC<Props> = ({
  year,
  cars = 0,
  events = 0,
  collections = 0,
  onOpen,
}) => {
  if (cars <= 0 && events <= 0 && collections <= 0) return null;

  return (
    <section className="mb-10">
      <Link
        to={`/passport/recap?year=${year}`}
        onClick={onOpen}
        className="block overflow-hidden rounded-2xl border border-white/[0.1] bg-gradient-to-r from-[#16120c] via-[#0e0e0e] to-[#0c1014] px-5 py-6 sm:px-7 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-400/60"
      >
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-amber-200/70">
          Year in Passport
        </p>
        <p className="mt-2 text-xl sm:text-2xl font-semibold text-white tracking-tight">
          Your {year} Passport
        </p>
        <p className="mt-2 text-sm text-zinc-400">
          {[
            cars > 0 ? `${cars} ${cars === 1 ? 'build' : 'builds'}` : null,
            events > 0 ? `${events} ${events === 1 ? 'event' : 'events'}` : null,
            collections > 0
              ? `${collections} ${collections === 1 ? 'collection' : 'collections'} complete`
              : null,
          ]
            .filter(Boolean)
            .join(' · ')}
        </p>
        <p className="mt-4 text-sm font-medium text-amber-100/90">View your recap →</p>
      </Link>
    </section>
  );
};

export default PassportRecapTeaser;
